import { equipmentSlice } from "./equipmentSlice";
import * as actions from "./equipmentActions";
import * as selectors from "./equipmentSelectors";

export { actions };
export { selectors };

export default equipmentSlice.reducer;
